export default __webpack_public_path__ + "static/media/desjardins.1fdc6743.svg";